/**
 * The feedback terminal (M2-DESIGN §6).
 *
 * This tab is a frame around `FeedbackForm`; the form owns the fields, the screenshot and
 * the POST. Sending bumps `round`, which remounts a clean form — a filled-in form left
 * sitting after a successful send invites accidental duplicates.
 */

import type { VNode } from 'preact';
import { useState } from 'preact/hooks';
import { FeedbackForm } from '../feedback-form.js';
import { Section, useSettings } from './common.js';
import type { HubController } from './common.js';
import type { HubHost } from './index.js';

export interface TerminalProps {
  ctl: HubController;
  host: HubHost;
  token: string;
}

export function Terminal(props: TerminalProps): VNode {
  const s = useSettings();
  const [round, setRound] = useState(0);
  const [sent, setSent] = useState('');

  return (
    <div class="hub-pane">
      <Section title="Terminal" hint="Goes straight to the people building this">
        <p class="hub-notice">
          Bugs, balance, ideas, a frame rate that will not hold — all of it lands in the same inbox,
          and the ones we act on come back in the Changelog with your report credited. The build,
          your GPU, the last minute of frame times and where you were standing are attached
          automatically.
        </p>
        {sent.length > 0 ? <p class="hub-sent">{sent}</p> : null}
        <FeedbackForm
          key={round}
          collector={props.host.collector}
          capture={props.host.capture}
          token={props.token}
          screenshotDefault={s.screenshotDefault}
          seedText=""
          onDone={(message) => {
            setSent(message);
            setRound(round + 1);
          }}
          onCancel={() => {
            setSent('');
            props.ctl.setTab('deploy');
          }}
        />
      </Section>
    </div>
  );
}
